/* eslint-disable @typescript-eslint/no-explicit-any */
import { postReportToServerNew } from "@/api/clientApi/report";
import { sdkManager } from "@/lib/sdk/sdkManager";
import { getUserChannel, userStore } from "@/stores/userStore";
import { GetReportContentRsp } from "@/types/swagger/extReport";

export function useReport() {
  const { general, channel } = getUserChannel();
  const handleAllReport = (data: GetReportContentRsp) => {
    try {
      if (data.data.length > 0) {
        const reportResultList: any[] = [];
        for (let i = 0; i < data.data.length; i++) {
          const el = data.data[i];

          const currency = "BRL";
          const nValue = el.pt || 0;

          const reportData: any = {
            event: el.event_name,
            event_fire: el.event_name == "register" ? "sign_up" : undefined,
            event_type:
              el.event_name == "register"
                ? "af_complete_registration"
                : "af_" + el.event_name,
            currency: currency,
            af_currency: currency,
            value: nValue, //FB需要
            revenue: nValue,
            af_revenue: nValue,
            ...el,
          };
          if (!reportData.general) {
            reportData.general = general;
          }
          if (!reportData.channel) {
            reportData.channel = channel;
          }
          if (!reportData.pid) {
            reportData.pid = userStore.userInfo?.pid || 0;
          }
          const reportResult: any = sdkManager.reportEvent(
            reportData.event,
            reportData,
          );

          if (reportResult && el.id) {
            const reportResultObj = {
              id: el.id,
              data: reportData,
            };
            reportResultList.push(reportResultObj);
          }
        }
        if (reportResultList.length) {
          reportToServerNew(reportResultList);
        }
      }
    } catch (error) {
      console.error("handleAllReport error", error);
    }
  };

  const reportToServerNew = (reportObjectList: any) => {
    const reportList: any[] = [];
    if (!Array.isArray(reportObjectList)) {
      reportObjectList = [reportObjectList];
    }
    reportObjectList.forEach((el: any) => {
      reportList.push({ id: el.id, data: JSON.stringify(el) });
    });
    if (reportList.length > 0) {
      postReportToServerNew(reportList);
    }
  };
  return {
    handleAllReport,
    reportToServerNew,
  };
}
